<template>
  <el-popconfirm
    v-bind="$attrs"
    :confirm-button-text="$attrs.confirmButtonText || '确定'"
    :cancel-button-text="$attrs.cancelButtonText || '取消'"
    :title="$attrs.title || '确定删除吗？'"
    :icon="$attrs.icon || 'el-icon-info'"
    :icon-color="$attrs.iconColor || '#f90'"
    :hide-icon="$attrs.hideIcon || false"
    @confirm="onConfirm"
    @cancel="onCancel"
  >
    <template #reference>
      <slot name="reference">
        <el-button :disabled="disabled" :type="btnType" :size="btnSize" :loading="loading" :icon="btnIcon">
          <slot></slot>
        </el-button>
      </slot>
    </template>
  </el-popconfirm>
</template>

<script>
export default {
  name: 'ShPopDelButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    btnIcon: {
      type: String,
      default: ''
    },
    btnType: {
      type: String,
      default: 'danger'
    },
    btnSize: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onConfirm() {
      document.activeElement?.blur()
      this.$emit('confirm')
    },
    onCancel() {
      document.activeElement?.blur()
      this.$emit('cancel')
    }
  }
}
</script>

<style></style>
